module.exports = __webpack_public_path__ + "static/ferry-banner-367dc7478e896bdaaa1b5a0044bd117b.png";